import { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Link } from "react-router-dom";
import GolbalMessage from "../common/globalMessage";

export default function SubscriptionPkg() {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Subscripton</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {GolbalMessage?.general?.pkgSubscription}{" "}
          </DialogContentText>

          <div></div>
        </DialogContent>
        <DialogActions>
          <button onClick={handleClose} className="btn btn-default">
            Cancel
          </button>
          <Link className="btn btn-success" to="/subscription" target="_blank">
            Make Payment
          </Link>
        </DialogActions>
      </Dialog>
      <i
        onClick={handleClickOpen}
        className="fa fa-info-circle infoCircle"
        title="View More Data"
      ></i>
    </>
  );
}
